import * as React from 'react';
export const JESvg = React.forwardRef(function JESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.21 2.16A2 2 0 0 1 2 2h12a2 2 0 0 1 .79.16L13.67 3H2.33l-1.12-.84Zm0 11.68A2 2 0 0 0 2 14h12a2 2 0 0 0 .79-.16L13.67 13H2.33l-1.12.84Zm14.5-10.87A2 2 0 0 1 16 4v8a2 2 0 0 1-.29 1.03L15 12.5v-9l.71-.53ZM.3 2.97A2 2 0 0 0 0 4v8c0 .36.1.72.29 1.03L1 12.5v-9l-.71-.53Z',
      fill: '#EAEEF3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.33 3h11.34L8 7.25 2.33 3Zm0 10h11.34L8 8.75 2.33 13ZM15 3.5v9L9 8l6-4.5Zm-14 0v9L7 8 1 3.5Z',
      fill: '#F6F9FC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M.29 2.97a2 2 0 0 1 .92-.8L8 7.24l6.79-5.09a2 2 0 0 1 .92.8L9 8l6.71 5.03a2 2 0 0 1-.92.8L8 8.76l-6.79 5.09a2 2 0 0 1-.92-.8L7 8 .29 2.97Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.96 4H6.04c.13 1.22.6 1.43 1.96 2 1.36-.57 1.83-.78 1.96-2Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10 2.5H6V3c0 .4.01.72.04 1h3.92c.03-.28.04-.6.04-1v-.5Z',
      fill: '#FCD669',
    }),
  );
});
JESvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var JE = {
  category: 'flag',
  colorable: false,
  name: 'JE',
  svg: JESvg,
};
